const SOCIALS = [
  { label: "Facebook — Bryan Cooper", img: "/assets/social-fb.png", href: "https://www.facebook.com/bryan.cooper", testid: "footer-social-facebook" },
  { label: "Instagram — bcooper_studios", img: "/assets/social-ig.png", href: "https://www.instagram.com/bcooper_studios", testid: "footer-social-instagram" },
  { label: "TikTok — bcooper_studios", img: "/assets/social-tt.png", href: "https://www.tiktok.com/@bcooper_studios", testid: "footer-social-tiktok" },
];

const STRIP_STYLE = {
  backgroundImage: "url('/assets/footer-bg.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const COPYRIGHT = "© MMXXVI B. Cooper Studios · Tulsa, Oklahoma";
const COPYRIGHT_CLASS =
  "text-[10px] uppercase tracking-[0.32em] text-[#7A8B80]";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-footer-strip" style={STRIP_STYLE}>
    {/* Desktop — exact 1440px PDF canvas (page y 2128–2397) */}
    <div className="canvas-1440 relative hidden h-[269px] lg:block">
      <div className="absolute left-0 right-0 top-[60px] flex justify-center gap-[11px]">
        {SOCIALS.map((s) => (
          <a key={s.testid} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} data-testid={s.testid}>
            <img src={s.img} alt="" className="w-[27px] transition-transform duration-300 hover:scale-110" />
          </a>
        ))}
      </div>
      <div
        aria-hidden="true"
        className="absolute left-0 right-0 top-[140px] h-[27px]"
        style={{
          backgroundImage: "url('/assets/bottom-band.png')",
          backgroundRepeat: "repeat-x",
          backgroundSize: "auto 27px",
          backgroundPosition: "center",
          maskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)",
        }}
      />
      <a href="/" aria-label="B. Cooper Studios — home">
        <img src="/assets/logo.png" alt="B. Cooper Studios" className="absolute left-[568px] top-[117px] w-[294px]" />
      </a>
      <p data-testid="footer-copyright" className={`absolute left-0 right-0 top-[210px] text-center ${COPYRIGHT_CLASS}`}>
        {COPYRIGHT}
      </p>
      <img
        src="/assets/footer-ornament.png"
        alt="Zan-o-Box Original"
        className="absolute left-[1208px] top-[72px] w-[147px]"
      />
    </div>

    {/* Mobile / tablet */}
    <div className="flex flex-col items-center px-6 py-8 lg:hidden">
      <div className="flex gap-3">
        {SOCIALS.map((s) => (
          <a key={s.testid + "-m"} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} data-testid={s.testid}>
            <img src={s.img} alt="" className="w-[26px]" />
          </a>
        ))}
      </div>
      <img src="/assets/logo.png" alt="B. Cooper Studios" className="mt-6 h-[58px] w-auto" />
      <p data-testid="footer-copyright-mobile" className={`mt-5 text-center ${COPYRIGHT_CLASS}`}>
        {COPYRIGHT}
      </p>
    </div>
  </footer>
);
